import { render, staticRenderFns } from "./WeeklyActivityPlan.vue?vue&type=template&id=36440b5f&scoped=true&"
import script from "./WeeklyActivityPlan.vue?vue&type=script&lang=js&"
export * from "./WeeklyActivityPlan.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=36440b5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36440b5f",
  null
  
)

export default component.exports